import React, { /*useEffect*/ } from 'react'

// Deps
import { connect } from 'react-redux'
import config from 'config'

// Partials
import Image from 'views/shared/partials/image'
import Link from 'views/shared/partials/link'

// Utils
import { openModal } from 'utils/modals';

// Services
import userServices from 'services/user'

// Static Assets
import Logo from 'assets/images/shared/logo.svg'

const mapStateToProps = (state, ownProps) => {
	return {
		mobileState: state.site.mobile,
		userData: state.user.data,
	};
};

const UserBar = (props) => {
	const userData = props.userData;

	const logout = () => {
		openModal('confirm', {
			message: 'Çıkış yapmak istediğinizden emin misiniz?',
			onConfirm: () => {
				setTimeout(() => {
					userServices.logout();
				}, 1000);
			},
		})
	}

	if(userData) {
		return (
			<header className="section header">
				{props.mobileState &&
					<div className="header-topbar">
						<button className={'topbar-menubtn' + (props.menuOpen ? ' open' : '')} onClick={props.onToggleMenu}>
							<i className="icon-menu menubtn-icon"></i>
						</button>
						<Link href="dashboard" className="topbar-logo">
							<Image
								className="logo-image"
								src={Logo} />
						</Link>
					</div>
				}
				<div className="header-userbar">
					<h1 className="userbar-name">
						{userData.company.invoice_name}
					</h1>

					<div className="userbar-userinfo">
						<span className="userinfo-name">
							<strong>{userData.name}</strong> {userData.surname}
						</span>
						<div className="userinfo-menu-outerwrap">
							<div className="userinfo-avatarwrap">
								{userData.company.logo_url &&
									<Image
										bg contain
										src={config.cdnUrl + 'company_logo/' + userData.company.logo_url}
										className="userinfo-avatar" />
								}
							</div>

							<div className="userinfo-menu">
								<div className="menu-innerwrap">
									<button
										className="menu-btn"
										type="button"
										onClick={() => { openModal('account', { accountID: userData.company_account_code}) }}>
										Profil Ayarları
									</button>
									<Link
										className="menu-btn"
										href="/terminal/dashboard">
										Terminal Görünümü
									</Link>
									<button
										className="menu-btn"
										type="button"
										onClick={logout}>
										Çıkış
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		)
	}
	else { return false; }
}

export default connect(mapStateToProps)(UserBar);